import React from 'react';

export const RerollAuthorityIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="50" viewBox="0 0 36 50" fill="none">
        <path
            d="M18 11.3636V18.1818L27 9.09091L18 0V6.81818C8.055 6.81818 0 14.9545 0 25C0 28.5682 1.035 31.8864 2.79 34.6818L6.075 31.3636C5.0625 29.4773 4.5 27.2955 4.5 25C4.5 17.4773 10.5525 11.3636 18 11.3636ZM33.21 15.3182L29.925 18.6364C30.915 20.5455 31.5 22.7045 31.5 25C31.5 32.5227 25.4475 38.6364 18 38.6364V31.8182L9 40.9091L18 50V43.1818C27.945 43.1818 36 35.0455 36 25C36 21.4318 34.965 18.1136 33.21 15.3182Z"
            fill="#0B60B0"
        />
    </svg>
);
